interface SectionProps {
  children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({ children }) => (
  <div className="flex flex-col w-full pt-5 pb-5">{children}</div>
);
